import { Link } from "react-router";
import { IconArrowRight } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import { DataProps } from "../../tools/components";
import { Wrapper } from "../layout/wrapper";
import RatioImage from "../medias/ratio-image";
import "./index-footer.scss";

const IndexFooter = ({ className, data }: DataProps<any>) => {

  const wrapperClasses = classNames("content cms-footer-links", className);

  return (
    <Wrapper.Centered className={wrapperClasses}>
      <div className="link-list">
        {data.map((item: any, index: number) => (
          <Link key={index} to={item["link-nav"]}>
            <RatioImage source={item["link-image"].assets}
                        alt={item["link-image"].alternativeText} />
            <span className="label">
              {item["link-label"]}
              <IconArrowRight />
            </span>
          </Link>)
        )}
      </div>
    </Wrapper.Centered>);

};

export default IndexFooter;
